

import InitialDelcop from "@/components/QualificationDelcop/InitialDelcop.vue"
import ApprovedDelcop from "@/components/QualificationDelcop/ApprovedDelcop.vue"
import ProcessDelcop from "@/components/QualificationDelcop/ProcessDelcop.vue"
import RejectedDelcop from "@/components/QualificationDelcop/RejectedDelcop.vue"
import { computed, onMounted } from 'vue';
import { useStore } from "vuex"
import router from '@/router'
import { ref } from 'vue'
import { useMutations } from '@/store/helper'
import PopUpTerminosCondiciones from "@/components/DocumentosLegales/PopUpTerminosCondiciones.vue";
import Spinner from "@/components/layout/Spinner.vue";

export default {
  name: "QualificationDelcop",
  components: {
    InitialDelcop,
    ProcessDelcop,
    ApprovedDelcop,
    RejectedDelcop,
    PopUpTerminosCondiciones,
    Spinner,
  },
  setup() {
    var intervalStateTestset: number;
    var errorResponse=ref('');

    const store = useStore();
    const stateHabilitacion = ref("");
    const urlvd = ref("");
    const spinnerView = ref(false);
    const paginaOrigen = ref("QualificationDelcop");
    const textoPopUpTYC = ref("Debido a nuestro cambio de aliado y a la habilitación que acabas de realizar, hemos renovado nuestros términos y condiciones. Tu experiencia es nuestra prioridad, y continuaremos brindándote el mejor servicio posible. Gracias por tu confianza.");
    const StoreVacio = ref(false);
    const nombreBotonConfirmTYC = ref("Finalizar");
    const mostrarPopUpTerminosCondiciones = ref(false);
    const siguientePaginaTYC = ref('Transmission');
    
    const { setStateMenu } = useMutations(['setStateMenu']);

    const estadoTerminosCondiciones = computed(() => store.state.datosTycTtd.find((doc) => doc.nombreDocumento.includes("Terminos y Condiciones"))?.aprobo);

    setStateMenu(true);

    function goToDashboard() {
      router.push({ name: 'Transmission' });
    }

    function cerrarPopUpTYC() {
      mostrarPopUpTerminosCondiciones.value = false
      store.dispatch('mostrarMenuHabilitacionAction', false);
      if(localStorage.getItem("DatosContactoRedireccion") == "Plans")
      {
        router.push({ name: 'Plans' })
      }
      else
      {
        goToDashboard();
      }     
    }

    function urlVideo(nombreVideo: string) {
      var params = {
        Token: localStorage.getItem("Tokensin"),
        NombreVideo: nombreVideo,
      };
      store.dispatch('GetUrlVideo', params).then(data => {
        urlvd.value = data.data;
      }).catch(error => {
        console.log(error);
      });
    }

    const changeState = (change: string) => {
      stateHabilitacion.value = change;
      if (change == "Rechazado") {
        closeInterval()
      } else {
        initializeInterval()
      }
    }

    const Download = () => {
      const url = process.env.VUE_APP_Gateway_API + "Empleador/DownloadInstructive?nombre=instructivo01.pdf";
      window.open(url, '_blank');
    }

    function GetStateTestSet() {
      store.dispatch('GetStateTestSet', localStorage.getItem('Tokensin')).then(data => {
        stateHabilitacion.value = data.data;
        closeInterval()
        if (stateHabilitacion.value == "Aprobado") {
          GetValidarAceptoTyC_V2()
        } else if (stateHabilitacion.value == "EnProceso" || 
        stateHabilitacion.value == "Inicial" ||
        stateHabilitacion.value == "ErrorTercero") {
          initializeInterval()
        }
        spinnerView.value = false;
      }).catch(error => {
        spinnerView.value = false;
      });
    }

    function RegistrarEmpleadorDelCop() {
      store.dispatch('RegistrarEmpleadorDelCop', localStorage.getItem('Tokensin')).then(data => {
        GetStateTestSet();
        GetValidarAceptoTyC_V2();
    }).catch(error => {
          spinnerView.value = false;
          if(error.status==400 || error.status==500){
            errorResponse.value="No es posible ingresar al Portal de Nómina Electrónica, por favor vuelve a intentar.";
            setStateMenu(false);
          }else{
            location.replace(process.env.VUE_APP_PortalEmpleador);
          }
      });
    }

    function closeInterval() {
      window.clearInterval(intervalStateTestset);
    }

    function initializeInterval() {
      intervalStateTestset = window.setInterval(GetStateTestSet, 40000);
    }

    function GetValidarAceptoTyC_V2() {
      let ParametrosEmpleador = {
        tipoIdentificacion: localStorage.getItem('TipoIdentificacion'),
        numeroIdentificacion: localStorage.getItem('Identificacion'),  
        token: localStorage.getItem("Tokensin")
      }
      store.dispatch('ConsultarDocumentosTyc_Ttd', ParametrosEmpleador).then(
        (response) =>{
          const aceptoTerminos = response.data.find(doc => doc.nombreDocumento.includes("Terminos y Condiciones"))?.aprobo; 
          validarOpenDialogTyC(aceptoTerminos);
        }).catch((err) => {
          console.log(err); 
        }
      );
    }

    function validarOpenDialogTyC(aceptoTerminos: boolean = false) {
      store.dispatch('mostrarMenuHabilitacionAction', (aceptoTerminos && stateHabilitacion.value == 'Aprobado') ? false : true);
      mostrarPopUpTerminosCondiciones.value = (!aceptoTerminos && stateHabilitacion.value == 'Aprobado') ? true : false;
      if(aceptoTerminos && stateHabilitacion.value == 'Aprobado') {
        closeInterval()
        goToDashboard()
      }
    }

    onMounted(() => {
      spinnerView.value = true;
      urlVideo("VideoHabilitacion.mp4");
      RegistrarEmpleadorDelCop();
    });

    return {
      goToDashboard,
      stateHabilitacion,
      changeState,
      Download,
      urlvd,
      textoPopUpTYC,
      nombreBotonConfirmTYC,
      StoreVacio,
      estadoTerminosCondiciones,
      paginaOrigen,
      mostrarPopUpTerminosCondiciones,
      siguientePaginaTYC,
      spinnerView,
      cerrarPopUpTYC,
      errorResponse
    };
  },
}; 
